export const WAVVE = 'wavve'
export const PARTNER = 'partner'

export const VOUCHER_TYPE = {
  WAVVE,
  PARTNER,
}

export const VOUCHER_TYPE_MAP = {
  wavve: VOUCHER_TYPE.WAVVE,
  partner: VOUCHER_TYPE.PARTNER,
}

export const VOUCHER_BANNER_MAP = {
  wavve: 0,
  partner: 0,
}

export const VOUCHER_TICKET_LIST = [
  {
    key: WAVVE,
    title: '웨이브 이용권',
  },
  {
    key: PARTNER,
    title: '제휴',
  },
]
